export function preserveTurboCableConnectionState(event) {
  const { attributeName, mutationType } = event.detail || {};
  if (
    event.target?.localName === 'turbo-cable-stream-source' &&
    attributeName === 'connected' &&
    mutationType === 'remove'
  ) {
    event.preventDefault();
  }
}
